// extracted by mini-css-extract-plugin
module.exports = {"separator":"fragment-separator_separator_OxuS4"};